
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { Cid, ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class CidEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    cid: Cid;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getCid()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getCid(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.cid = data;
                this.onDataChanged.next(this.cid);
                resolve(this.cid);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('cid/' + this.routeParams.id).subscribe({next:(res: Cid ) => {
                    this.cid = res;
                    this.onDataChanged.next(this.cid);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(cid): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('cid/', cid).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    edit(cid): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('cid/', cid).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(cid): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('cid/' + cid.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): Cid {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
